import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=7fe77e7c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=7fe77e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe77e7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fe77e7c')) {
      api.createRecord('7fe77e7c', component.options)
    } else {
      api.reload('7fe77e7c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=7fe77e7c&scoped=true&", function () {
      api.rerender('7fe77e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2d2e2SgEypq8J/JS/comp/PopupBox.vue"
export default component.exports